<style scoped lang="less">
@import './style.less';
</style>
<script>
import methods from './methods.js'

export default {
  name: "list",
  mixins: [methods]
}
</script>
<template>
  <transition-group class="list" name="bar-list" tag="div" v-if="list.length">
    <div class="list_row" v-for="row of list" :key="row.name">
      <div class="list_row_title">
        <div class="list_row_title_icon" :style="`background: ${row.color}`"/>
        <div class="list_row_title_text">{{row.name}}</div>
      </div>
      <div class="list_row_value">{{row.value}}</div>
      <div class="list_row_value">{{row.percentage}}</div>
    </div>
  </transition-group>
  <!-- <none-data :height="3.5" v-if="isEmpty"></none-data> -->
</template>

